import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Flex,
  FormControlLabel,
  SearchInput,
  Typography,
} from '@knockrentals/knock-shared-web-v2';
import { Paper } from '@material-ui/core';
import {
  FeatureDrawerActions,
  FeatureDrawerContent,
  makeCss,
} from '../../../../../knock-design-system';
import { useChannelSelection } from '../use-channel-selection';

const useCss = makeCss({
  drawerContent: {
    alignItems: 'stretch',
  },
  hintText: {
    paddingLeft: '8px',
  },
  listContainer: {
    flex: 1,
    overflowY: 'auto',
  },
  searchInput: {
    width: 'unset',
  },
});

export const ShowHideChannels = ({ handleDrawerMode }) => {
  const [searchString, setSearchString] = useState('');

  const css = useCss();
  const {
    amountChannelsSelected,
    areAllChannelsSelected,
    channels,
    channelSelectionMap,
    isIndeterminate,
    updateChannelSelection,
    updateAllChannelsSelections,
  } = useChannelSelection();

  const filteredChannels = searchString
    ? channels.filter((channel) =>
        channel.channelName.toLowerCase().includes(searchString.toLowerCase())
      )
    : channels;

  const handleChannelCheckboxOnChange = (e) => {
    const { checked: isSelected, name: channelId } = e.target;
    updateChannelSelection(channelId, isSelected);
  };

  const clearSearchFilter = () => {
    setSearchString('');
  };

  return (
    <React.Fragment>
      <FeatureDrawerContent css={css.drawerContent}>
        <SearchInput
          css={css.searchInput}
          placeholder="Search Channels"
          onClear={clearSearchFilter}
          onChange={setSearchString}
          value={searchString}
        />

        <Flex
          alignItems="center"
          paddingLeft="0 8px"
          justifyContent="space-between"
        >
          <FormControlLabel
            color="secondary.200"
            control={
              <Checkbox
                checked={areAllChannelsSelected}
                color="default"
                indeterminate={isIndeterminate}
                onChange={updateAllChannelsSelections}
              />
            }
            label="Show all"
          />
          <Typography color="secondary.500" variant="caption">
            {amountChannelsSelected} of {channels.length} channels shown
          </Typography>
        </Flex>

        <Paper variant="outlined" css={css.listContainer}>
          <Flex flexDirection="column" padding="20px" gap={10}>
            {filteredChannels.map((channel) => {
              const { id, channelName, enablePropertyCount } = channel;
              const { isSelected = false } = channelSelectionMap[id] || {};
              return (
                <FormControlLabel
                  color="secondary.200"
                  control={
                    <Checkbox
                      color="default"
                      checked={isSelected}
                      name={id}
                      onChange={handleChannelCheckboxOnChange}
                    />
                  }
                  key={id}
                  label={
                    <React.Fragment>
                      <Typography variant="body2">{channelName}</Typography>
                      <Typography color="secondary.700" variant="caption">
                        {enablePropertyCount} properties
                      </Typography>
                    </React.Fragment>
                  }
                />
              );
            })}
          </Flex>
        </Paper>

        <Typography css={css.hintText} color="secondary.500" variant="caption">
          *Enabled channels cannot be hidden
        </Typography>
      </FeatureDrawerContent>

      <FeatureDrawerActions
        closeDrawer={handleDrawerMode(null)}
        primaryButtonText="Apply"
        secondaryButtonText="Cancel"
      />
    </React.Fragment>
  );
};

ShowHideChannels.propTypes = {
  handleDrawerMode: PropTypes.func,
};
